<template>
  <el-card>
    <template #header>
      <content-header />
    </template>

    <el-button-group class="mb-3">
      <search-form :fields="search" />
      <button-link v-if="hasPermsCreate" :to="`goods/create`">添加</button-link>
    </el-button-group>

    <el-table :data="goods" resource="goods">
      <el-table-column prop="id" label="编号" width="60" />
      <el-table-column prop="name" label="标题" />
      <el-table-column prop="category.title" label="商品分类" width="100" />
      <el-table-column prop="goods_type_text" label="商品类型" width="80" />
      <el-table-column prop="sales_type_text" label="销售类型" width="80" />
      <el-table-column prop="price" label="零售价" width="100" />
      <el-table-column prop="store_count" label="总库存" width="100" />
      <el-table-column label="是否上架" width="100">
        <template slot-scope="scope">
          <el-switch v-model="scope.row.marketable" disabled />
        </template>
      </el-table-column>
      <el-table-column prop="created_at" label="添加时间" width="170" />

      <el-table-column label="操作" width="250">
        <template slot-scope="scope">
          <el-button-group>
            <el-tooltip v-if="hasPermsEdit" effect="dark" content="修改商品" placement="top">
              <button-link size="small" :to="'/goods/' + scope.row.id + '/edit'"><slot>修改</slot></button-link>
            </el-tooltip>

            <!-- <el-tooltip v-if="hasPermsChangeStoreCount" veffect="dark" content="修改库存" placement="top">
              <el-button size="small" @click="onChangeStoreCount(scope.$index, scope.row)">库存</el-button>
            </el-tooltip> -->

            <el-tooltip v-if="hasPermsStatus" effect="dark" :content="scope.row.marketable === true ? '下架' : '上架'" placement="top">
              <el-popconfirm
                confirm-button-text="好的"
                cancel-button-text="不用了"
                icon="el-icon-info"
                icon-color="red"
                :title="'确定要' + (scope.row.marketable === true ? '下架' : '上架') + '吗？'"
                @confirm="onConfirm(scope.$index, scope.row)"
              >
                <el-button :type="scope.row.marketable === true ? 'warning' : ''" size="small" slot="reference">{{
                  scope.row.marketable === true ? '下架' : '上架'
                }}</el-button>
              </el-popconfirm>
            </el-tooltip>

            <el-tooltip effect="dark" content="删除商品" v-if="hasPermsDelete" placement="top">
              <el-popconfirm
                confirm-button-text="好的"
                cancel-button-text="不用了"
                icon="el-icon-info"
                icon-color="red"
                title="确定要删除商品吗？"
                @confirm="onDestroyConfirm(scope.$index, scope.row)"
              >
                <el-button type="danger" size="small" slot="reference">删除</el-button>
              </el-popconfirm>
            </el-tooltip>
          </el-button-group>
        </template>
      </el-table-column>
    </el-table>
    <div class="card-footer"><pagination :page="page" /></div>

    <el-dialog title="设置库存" :visible.sync="setStoreCountDialog" width="400px" append-to-body>
      <lz-form
        style="width: auto;"
        ref="form"
        :submit="onStoreCountSubmit"
        :errors.sync="errors"
        :form.sync="form"
        label-position="top"
        in-dialog
        disable-redirect
        disable-stay
      >
        <el-form-item label="库存数量" required prop="store_count">
          <input id="goods_id" name="goods_id" type="hidden" class="form-control" v-model="form.id" />
          <el-input v-model="form.store_count" autofocus />
          <el-alert title="正整数即表示追加库存，负整数表示减库存" type="info" show-icon :closable="false" />
        </el-form-item>
        <el-form-item label="备注" required prop="remark">
          <el-input type="textarea" :autosize="{ minRows: 2, maxRows: 3 }" v-model="form.remark" />
        </el-form-item>
      </lz-form>
    </el-dialog>
  </el-card>
</template>

<script>
import { changeStoreCount, destroyGood, getGoods, updateGoodStatus } from '@/api/goods'
import { can, getMessage } from '@/libs/utils'
import ButtonLink from '@c/ButtonLink'
import LzForm from '@c/LzForm'
import Pagination from '@c/Pagination'
import SearchForm from '@c/SearchForm'

export default {
  name: 'Index',
  components: {
    LzForm,
    SearchForm,
    Pagination,
    ButtonLink,
  },
  data() {
    return {
      search: [
        {
          field: 'name',
          label: '标题(模糊搜索)',
        },
        {
          field: 'marketable',
          label: '状态',
          type: 'el-select',
          options: [
            { id: 1, name: '已上架' },
            { id: 0, name: '已下架' },
          ],
          labelField: 'name', // 默认为 name
          valueField: 'id', // 默认为 id
        },
        {
          field: 'goods_type',
          label: '商品类型',
          type: 'el-select',
          options: [
            { id: 0, name: '普通商品' },
            { id: 1, name: '报单商品' },
            { id: 2, name: '积分商品' },
          ],
          labelField: 'name', // 默认为 name
          valueField: 'id', // 默认为 id
        },
        {
          field: 'sales_type',
          label: '销售类型',
          type: 'el-select',
          options: [
            { id: 1, name: '线上平台' },
            { id: 2, name: '线下平台' },
            { id: 3, name: '所有平台' },
          ],
          labelField: 'name', // 默认为 name
          valueField: 'id', // 默认为 id
        },
      ],
      goods: [],
      page: null,
      setStoreCountDialog: false,
      form: {
        id: 0,
        store_count: '',
        remark: '',
      },
      errors: {},
      hasPermsDelete: false,
      hasPermsCreate: false,
      hasPermsEdit: false,
      hasPermsStatus: false,
      hasPermsChangeStoreCount: false,
    }
  },
  methods: {
    async loadData(newVal) {
      const {
        data: { data, meta },
      } = await getGoods(newVal)
      this.goods = data
      this.page = meta
    },
    async onChangeStoreCount(index, row) {
      this.setStoreCountDialog = true
      this.form = { id: row.id, store_count: '', remark: '' }
    },
    async onStoreCountSubmit() {
      await changeStoreCount(this.form)

      this.setStoreCountDialog = false
      this.clearForm()

      // this.$message.success(getMessage('default'))
      await this.loadData({})
    },
    async onDestroyConfirm(index, row) {
      await destroyGood(row.id)
      this.$message.success(getMessage('destroyed'))
      await this.loadData({})
    },
    async onConfirm(index, row) {
      await updateGoodStatus(row.id)
      this.$message.success(getMessage('updated'))
      await this.loadData({})
    },
    clearForm() {
      this.form = {
        id: 0,
        store_count: '',
        remark: '',
      }
    },
  },
  watch: {
    $route: {
      async handler(newVal) {
        this.loadData(newVal.query)
      },
      immediate: true,
    },
    setStoreCountDialog(newVal) {
      if (!newVal) {
        this.clearForm()
      }
    },
  },
  created() {
    this.hasPermsDelete = can('goods.delete')
    this.hasPermsEdit = can('goods.edit')
    this.hasPermsCreate = can('goods.create')
    this.hasPermsStatus = can('goods.status')
    this.hasPermsChangeStoreCount = can('goods.change-store-count')
  },
}
</script>
